export type DateInterval = "Second" | "Minute" | "Hour" | "Day" | "Week" | "Month" | "Quarter" | "Year";
